import { useAuth } from '../contexts/AuthContext';

export function usePermission(permission: string): boolean {
  const { permissions } = useAuth();
  return permissions.includes(permission);
}

export function usePermissions(requiredPermissions: string[]): boolean[] {
  const { permissions } = useAuth();
  return requiredPermissions.map((permission) => permissions.includes(permission));
}
